export default __webpack_public_path__ + "static/media/prithiva_topaz_chunk.fa00159e.png";